module.exports = __webpack_public_path__ + "img/center.6468db11.png";